// import { user } from '@/services/index';

export default {
  namespaced: true,
  
  state: {
    data: JSON.parse(localStorage.getItem('user')),
  },
  
  getters: {
    data: state => state.data,
  },

  mutations: {
    SET_DATA(state, userData) {
      state.data = userData;
    },
  },

  actions: {
    // async fetchData(context) {
    //   await user.get()
    //     .then((response) => {
    //       if (response.data) {
    //         context.commit('SET_DATA', response.data)
    //       }
    //     })
    //     .catch((error) => {
    //       console.warn(error)
    //     })
    // },
  }
};